var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35084 2H5.45084C3.26084 2 2.11084 3.15 2.11084 5.33V7.23C2.11084 9.41 3.26084 10.56 5.44084 10.56H7.34084C9.52084 10.56 10.6708 9.41 10.6708 7.23V5.33C10.6808 3.15 9.53084 2 7.35084 2Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7808 2H16.8808C14.7008 2 13.5508 3.15 13.5508 5.33V7.23C13.5508 9.41 14.7008 10.56 16.8808 10.56H18.7808C20.9608 10.56 22.1108 9.41 22.1108 7.23V5.33C22.1108 3.15 20.9608 2 18.7808 2Z",
    fill: "#0033CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7808 13.4297H16.8808C14.7008 13.4297 13.5508 14.5797 13.5508 16.7597V18.6597C13.5508 20.8397 14.7008 21.9897 16.8808 21.9897H18.7808C20.9608 21.9897 22.1108 20.8397 22.1108 18.6597V16.7597C22.1108 14.5797 20.9608 13.4297 18.7808 13.4297Z",
    fill: "#0033CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35084 13.4297H5.45084C3.26084 13.4297 2.11084 14.5797 2.11084 16.7597V18.6597C2.11084 20.8497 3.26084 21.9997 5.44084 21.9997H7.34084C9.52084 21.9997 10.6708 20.8497 10.6708 18.6697V16.7697C10.6808 14.5797 9.53084 13.4297 7.35084 13.4297Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.154d0240c8a950cd344d9c39a0b9ac7f.svg";
export { ForwardRef as ReactComponent };